import React, { useState, useEffect } from 'react';

interface SpinnerProps {
  items: string[];
  interval?: number;
  className?: string;
  color?: string;
}

const Spinner: React.FC<SpinnerProps> = ({ items, interval = 2000, className = "", color }) => {
  const [currentDisplay, setCurrentDisplay] = useState(items[0] || '');
  const [targetIndex, setTargetIndex] = useState(0);
  const [animationStep, setAnimationStep] = useState(0);

  useEffect(() => {
    if (items.length <= 1) return;

    const timer = setInterval(() => {
      setTargetIndex((prev) => (prev + 1) % items.length);
      setAnimationStep(0);
    }, interval);
    return () => clearInterval(timer);
  }, [items.length, interval]);

  useEffect(() => {
    const target = items[targetIndex] || '';
    const maxLen = Math.max(currentDisplay.length, target.length);
    if (animationStep >= maxLen) return;

    const timer = setTimeout(() => {
      const currentPadded = currentDisplay.padEnd(maxLen, ' ');
      const targetPadded = target.padEnd(maxLen, ' ');
      const newChar = targetPadded[animationStep];
      const newDisplay = currentPadded.substring(0, animationStep) + newChar + currentPadded.substring(animationStep + 1);
      setCurrentDisplay(newDisplay.trimEnd());
      setAnimationStep(prev => prev + 1);
    }, interval/maxLen/2);

    return () => clearTimeout(timer);
  }, [animationStep, currentDisplay, items, targetIndex]);

  if (items.length === 0) return null;

  const style = color ? { color } : {};

  return (
    <span className={className} style={style}>{currentDisplay}</span>
  );
};

export default Spinner;
